<div class="container-fluid customer-review">
  <div class="row breadcrumb-wrapper">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <app-breadcrumb></app-breadcrumb>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <div class="container">
        <h1 class="page-sub-title cv-text-dark mb-4 mt-4">Customer Reviews</h1>
        <div class="row position-relative">
          <a href="javascript:void(0);" class="wishlist">
            <div class="ms-auto utility-btn">
              <span>
                <button (click)="clickToAddWishlist(productDetailList?.id)">
                      <span *ngIf="!productDetailList?.wishlist">
                        <img [src]="environment1 + 'images/new-images/heart.svg'" alt="heart" loading="lazy">
                    </span>
                    <span  *ngIf="productDetailList?.wishlist">
                      <img [src]="environment1 + 'images/new-images/fillHeart.svg'" alt="fillHeart" loading="lazy">
                    </span>
                </button>
              </span>
            </div>
          </a>
          <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
            <div class="card">
              <div class="card-body">
                <img [src]="this.productDetailList?.images[0]?.image_url" class="img-fluid" alt="{{ this.productDetailList?.model }}" loading="lazy">
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 col-xxl-8">
            <div class="product-name">{{ this.productDetailList?.model }}</div>
            <div class="rating">
              <span class="rating-clip">
                {{totalRating}}
                <img [src]="environment1 + 'images/new-images/star.svg'" alt="star" loading="lazy">
              </span>
              <span class="ps-3 rating-text">{{totalReviewsCount}} Ratings and {{descriptionCount}} Reviews</span>
            </div>
            <div class="price">
            {{productDetailList?.price_range | currency:'INR':'symbol':'4.0-0'}}  <span>Ex-showroom Price</span>
            </div>
            <div class="row g-4">
              <div class="col-6" *ngIf="productDetailList.sub_lob=='SCV Pickups'">
                <button type="button" (click)="bookTestDrive()"
                class="btn btn-outline-primary btn-grad-outline-primary btn-brand btn-lg ps-5 pe-5 pt-3 pb-3 me-sm-4 w-100"
                data-toggle="tooltip" data-placement="top" title="Click here to Book a Test Drive"
                >Book a Test Drive</button>
              </div>
              <div class="col-6">
                <button type="button" (click)="bookNow()"
                class="btn btn-primary btn-lg btn-grad-primary btn-brand ps-5 pe-5 pt-3 pb-3 w-100"
                data-toggle="tooltip" data-placement="top" title="Click here for Booking"
                >Book Now At {{productDetailList?.down_payment | currency:'INR':'symbol':'4.0-0'}}  </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="stripe-sec">
  <div class="container">
    <div class="flx-item">
      <div class="review-count">
        <p>{{totalReviewsCount}} Reviews found</p>
      </div>
      <div class="filter">
        <label>Sort by </label>

        <select class="form-select" (change)="onFilterChange($event,'')">
          <option [value]="item" *ngFor="let item of sortList">{{item}}</option>
        </select>
      </div>
    </div>
  </div>

</div>
<div class="rating-section pt-5 pb-5">
  <div class="container">
    <h1 class="page-sub-title cv-text-dark mb-4">Rating and Reviews</h1>
    <div class="row gy-5">
      <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-4 col-xxl-4">
        <div class="row align-items-center">
          <div class="col-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
            <div class="total-rating">
              {{totalRating}}
              <img [src]="environment1 + 'images/new-images/star.svg'" style="width: 25%;" alt="star" loading="lazy">
              <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
                <path
                  d="M8 0L9.79611 5.52786H15.6085L10.9062 8.94427L12.7023 14.4721L8 11.0557L3.29772 14.4721L5.09383 8.94427L0.391548 5.52786H6.20389L8 0Z"
                  fill="#FDC602" />
              </svg> -->
              <br />

            </div>
            <div class="total-rating-desc">
              <span class="text-center">
                {{totalReviewsCount}} Rating <br />
                and {{descriptionCount}} review
              </span>

            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-7 col-lg-8 col-xl-8">
            <div class="rating-progress-bar">
              <div class="total-rated-star">
                5
                <img style="margin-left: 5px;" [src]="environment1 + 'images/new-images/star.svg'"  alt="star" loading="lazy">
              </div>
              <div class="progress">
                <div class="progress-bar bg-success" role="progressbar" [ngStyle]="{'width':getRatingValue(fiveStarRatingCount)}" aria-valuenow="10"
                  aria-valuemin="0" aria-valuemax="100"></div>
              </div>
              <div class="total-rated">
                {{ fiveStarRatingCount }}
              </div>
            </div>
            <div class="rating-progress-bar">
              <div class="total-rated-star">
                4
                <img style="margin-left: 5px;" [src]="environment1 + 'images/new-images/star.svg'"  alt="star" loading="lazy">
              </div>
              <div class="progress">
                <div class="progress-bar bg-success" role="progressbar"  [ngStyle]="{'width':getRatingValue(fourStarRatingCount)}" aria-valuenow="10"
                  aria-valuemin="0" aria-valuemax="100"></div>
              </div>
              <div class="total-rated">
                {{ fourStarRatingCount }}
              </div>
            </div>
            <div class="rating-progress-bar">
              <div class="total-rated-star">
                3
                <img style="margin-left: 5px;" [src]="environment1 + 'images/new-images/star.svg'"  alt="star" loading="lazy">
              </div>
              <div class="progress">
                <div class="progress-bar bg-success" role="progressbar" [ngStyle]="{'width':getRatingValue(threeStarRatingCount)}" aria-valuenow="10"
                  aria-valuemin="0" aria-valuemax="100"></div>
              </div>
              <div class="total-rated">
                {{ threeStarRatingCount }}
              </div>
            </div>
            <div class="rating-progress-bar">
              <div class="total-rated-star">
                2
                <img style="margin-left: 5px;" [src]="environment1 + 'images/new-images/star.svg'"  alt="star" loading="lazy">
              </div>
              <div class="progress">
                <div class="progress-bar bg-warning" role="progressbar" [ngStyle]="{'width':getRatingValue(twoStarRatingCount)}" aria-valuenow="10"
                  aria-valuemin="0" aria-valuemax="100"></div>
              </div>
              <div class="total-rated">
                {{ twoStarRatingCount }}
              </div>
            </div>
            <div class="rating-progress-bar">
              <div class="total-rated-star">
                1
                <img style="margin-left: 5px;" [src]="environment1 + 'images/new-images/star.svg'"  alt="star" loading="lazy">
              </div>
              <div class="progress">
                <div class="progress-bar bg-danger" role="progressbar" [ngStyle]="{'width':getRatingValue(oneStarRatingCount)}" aria-valuenow="10"
                  aria-valuemin="0" aria-valuemax="100"></div>
              </div>
              <div class="total-rated">
                {{ oneStarRatingCount }}
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-5 circle-progress">
            <div class="row">
              <div class="col text-center">
                <circle-progress [percent]="safety" [radius]="100"></circle-progress>
                <div class="text-center">
                  Safety
                </div>
              </div>
              <div class="col">
                <circle-progress [percent]="performance" [radius]="100"></circle-progress>
                <div class="text-center">
                  Performance
                </div>
              </div>
              <div class="col">
                <circle-progress [percent]="design" [radius]="100"></circle-progress>
                <div class="text-center">
                  Design
                </div>
              </div>
              <div class="col">
                <circle-progress [percent]="comfort" [radius]="100"></circle-progress>
                <div class="text-center">
                  Comfort
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <button type="button" class="btn btn-primary btn-lg btn-grad-primary btn-brand w-100"
            (click)="getUserWiseProductRating()"
            data-toggle="tooltip" data-placement="top" title="Click here to Write a review"
            >Write a review</button>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 offset-xl-1">
        <div class="row mb-4" *ngFor="let item of productRatingList">
          <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
            <div class="user-info">
              <div class="rating">
                <ng-container *ngFor="let rating of item.rating_master">
                  <ngx-stars *ngIf="rating.parameter == 'overall'" [readonly]="true" [customStarIcons]="heartUrls"
                    [color]="'#FDC602'" [initialStars]="rating.rating" [size]="5"></ngx-stars>
                </ng-container>
              </div>
              <div class="user-name">
                {{item?.first_name}}&nbsp; {{item?.last_name}}
              </div>
              <div class="time">
                {{item.updated_date | dateAgo}}
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9">
            <div class="review">
              <h3>{{item?.title}}</h3>
              <p>
                {{item?.description}}
              </p>
              <div class="review-image-vedio-wrapper" *ngFor="let images of item.image">
                <div class="img">
                    <img class="img-fluid" [src]="images" loading="lazy"/>
                </div>
            </div>
          </div>
        </div>
        <div class="row align-items-center" *ngIf="productRatingList?.length == 0">
          <div class="col-12">
            <div class="no-rating-frame">
              <div class="text-center  mb-3">
                <img [src]="environment1 + 'images/new-images/rating.svg'" alt="rating" loading="lazy">
              </div>
              <div class="text-center no-customer-rating-text">
                There are no customer ratings or review for this product.
              </div>
              <div class="d-flex align-items-center">
                <div class="no-rating-content">
                  <h4>Be the first one to review this product</h4>
                  <p class="mb-0">Share your thoughts with other customers</p>
                </div>
                <div class="ms-auto">
                  <button type="button" class="btn btn-primary btn-lg btn-grad-primary btn-brand w-100"
                  (click)="getUserWiseProductRating()"
                  data-toggle="tooltip" data-placement="top" title="Click here to Write a review"
                  >Write a review</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9">
            <div class="review">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Modal -->
<div *ngIf="isShowPopup" class="modal fade" id="exampleModal" tabindex="-1" role="dialog"
  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Move to login</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        You are not logged in, Please click "YES" to login !
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">No</button>
        <button type="button" class="btn btn-primary" [routerLink]="'/login'">Yes</button>
      </div>
    </div>
  </div>
</div>
<ng-template #productReview let-d="dismiss4">
  <app-product-review [data]="productReviewData"></app-product-review>
</ng-template>
